import React from 'react'
import styled from 'styled-components'

import { BjmGutLogo } from '@/components/shared/icons/logos/BjmGutLogo'
import { NatureLogo } from '@/components/shared/icons/logos/NatureLogo'
import { ScienceLogo } from '@/components/shared/icons/logos/ScienceLogo'
import { TheLancetLogo } from '@/components/shared/icons/logos/TheLancetLogo'
import { University } from '@/components/shared/icons/University'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 72px;
  text-align: center;
  align-items: center;
  background: #2d3246;
  max-width: 1200px;
  margin: 0 auto;
  border-radius: 24px;
  padding: 72px 32px;
  color: ${(props) => props.theme.v2.surface.white};

  h2 {
    max-width: 880px;
    margin: 0;
    font-family: ${(p) => p.theme.v2.font.nantes};
    font-size: 46px;
    line-height: 64px;

    @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
      font-size: 34px;
      line-height: 48px;
    }
  }

  p {
    max-width: 620px;
    margin: 0;
    font-family: ${(p) => p.theme.v2.font.lotaGrotesqueLight};
    font-size: ${(p) => p.theme.v2.typography.body.m.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.m.lineHeight};
    @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
      font-size: ${(p) => p.theme.v2.typography.body.s.fontSize};
      line-height: ${(p) => p.theme.v2.typography.body.s.lineHeight};
    }
  }

  @media screen and (max-width: ${(p) => p.theme.breakpoints.desktop}) {
    padding: 72px 16px;
  }
`

const StyledRow = styled.div`
  display: flex;
  gap: 48px;
  justify-content: center;
  margin-top: 32px;

  svg {
    height: 24px;
  }

  @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
    flex-direction: column;
    gap: 32px;
    align-items: center;

    svg {
      height: 32px;
    }
  }
`

const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const StyledSeparator = styled.hr`
  background-color: ${(props) => props.theme.v2.surface.white};
  width: 100%;
  height: 1px;
  border: none;
  opacity: 0.2;
`

const StyledImageText = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;

  span {
    font-family: ${(p) => p.theme.v2.font.nantes};
    font-size: ${(p) => p.theme.v2.typography.body.l.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.l.lineHeight};
  }
`

export const GutShotScienceSection = () => {
  return (
    <StyledContainer>
      <h2>Created by the team bringing groundbreaking science to the world</h2>

      <StyledColumn>
        <p>
          Our experts lead nutrition research studies with scientists at the world’s most respected research
          institutions.
        </p>
        <StyledRow>
          <StyledImageText>
            <University colour="white" />
            <span>Stanford Medicine</span>
          </StyledImageText>
          <StyledImageText>
            <University colour="white" />
            <span>Massachusetts General Hospital</span>
          </StyledImageText>
          <StyledImageText>
            <University colour="white" />
            <span>King&apos;s College London</span>
          </StyledImageText>
        </StyledRow>
      </StyledColumn>

      <StyledSeparator />

      <StyledColumn>
        <p>Our team has written over 100 peer-reviewed papers published in top medical journals.</p>
        <StyledRow>
          <NatureLogo colour="white" />
          <ScienceLogo colour="white" />
          <TheLancetLogo colour="white" />
          <BjmGutLogo colour="white" />
        </StyledRow>
      </StyledColumn>
    </StyledContainer>
  )
}
